export class Validacao {
  public id: number;
  public codigoEstudoSocioEconomico: number;
  public codigoGrupoFamiliar: number;
  public codigoPergunta: number;
  public descricao: string;
  public corrigido: boolean;
  public dataInclusao: Date;
  public dataCorrigido: Date;
  public idUsuario: number;

  // campos transient
  public validacaoValida: boolean;
  public perguntaEnunciado: string;
  public perguntaIdentificacao: string;
  public listaRespostaItem: any;
}
